var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlow1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 63,
    viewBox: "0 0 66 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 27.9167C1.25 12.5833 14.5833 1.25 32.5833 1.25C50.5833 1.25 63.9167 12.5833 63.9167 27.9167C63.9167 43.25 50.5833 54.5833 32.5833 54.5833C27.9167 54.5833 23.25 53.9167 19.25 51.9167L6.58333 61.25L8.58333 45.25C3.91667 40.5833 1.25 34.5833 1.25 27.9167Z",
    stroke: "#12171C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5835 31.917C22.7926 31.917 24.5835 30.1261 24.5835 27.917C24.5835 25.7079 22.7926 23.917 20.5835 23.917C18.3744 23.917 16.5835 25.7079 16.5835 27.917C16.5835 30.1261 18.3744 31.917 20.5835 31.917Z",
    fill: "#FF6000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5835 31.917C34.7926 31.917 36.5835 30.1261 36.5835 27.917C36.5835 25.7079 34.7926 23.917 32.5835 23.917C30.3744 23.917 28.5835 25.7079 28.5835 27.917C28.5835 30.1261 30.3744 31.917 32.5835 31.917Z",
    fill: "#FF6000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5835 31.917C46.7926 31.917 48.5835 30.1261 48.5835 27.917C48.5835 25.7079 46.7926 23.917 44.5835 23.917C42.3744 23.917 40.5835 25.7079 40.5835 27.917C40.5835 30.1261 42.3744 31.917 44.5835 31.917Z",
    fill: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow1);
export default __webpack_public_path__ + "static/media/flow1.fa3d488e1e1a3edbb38ecd4df26d7825.svg";
export { ForwardRef as ReactComponent };